import React, { useMemo } from 'react'

import { selectSelectedDocumentType, setSelectedDocumentType } from '../../../store/processDocument/document'
import { selectDocumentTypes } from '../../../store/processDocument/documentTypes'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { SelectDropdown, SelectOption } from '../../../components/SelectDropdown/SelectDropdown'

interface DocumentTypeSelectDropdownProps {
  disabled?: boolean
}

export const DocumentTypeSelectDropdown: React.FC<DocumentTypeSelectDropdownProps> = ({ disabled = false }) => {
  const dispatch = useAppDispatch()

  const selectedDocumentType = useAppSelector(selectSelectedDocumentType)
  const documentTypes = useAppSelector(selectDocumentTypes)

  const options = useMemo(() => documentTypes.map((e) => ({ id: e.id, label: e.name })), [documentTypes])
  const selectedOption = useMemo(
    () => (selectedDocumentType ? { id: selectedDocumentType.id, label: selectedDocumentType.name } : null),
    [selectedDocumentType],
  )

  const handleOptionSelected = (option: SelectOption) => {
    const selectedDocumentType = documentTypes.find((e) => e.id === option.id)
    if (!selectedDocumentType) {
      return
    }
    dispatch(setSelectedDocumentType(selectedDocumentType))
  }

  return (
    <SelectDropdown
      className='py-2 zocks-px-0.75 bold'
      icon='bi-file-earmark-richtext'
      options={options}
      onOptionSelected={handleOptionSelected}
      initialSelectedOption={selectedOption}
      disabled={disabled}
    />
  )
}
